/**
 * Cabinet (app.graweo.org) integration config.
 *
 * The public site links visitors to the separate charity cabinet for
 * login/registration. A shared cross-subdomain cookie (`graweo_auth`, set by
 * the cabinet on the .graweo.org domain) tells the public site whether the
 * visitor is registered — used to gate the reports section.
 */

const APP_URL = (process.env.REACT_APP_CABINET_URL || 'https://app.graweo.org').replace(/\/$/, '');

export const CABINET_URL = APP_URL;
export const LOGIN_URL = `${APP_URL}/login`;
export const REGISTER_URL = `${APP_URL}/register`;

/** Non-httpOnly cookie set by the cabinet on `.graweo.org` after auth. */
export const AUTH_COOKIE = 'graweo_auth';

/**
 * Localized labels for the auth CTA and the reports registration wall.
 * Kept here (not in the big translations table) so the feature is
 * self-contained. Falls back to English for any missing locale.
 */
export const AUTH_LABELS = {
  en: {
    login: 'Login / Sign up',
    cabinet: 'My account',
    gate_title: 'Reports are available after registration',
    gate_text: 'Log in or create a free account to access the foundation’s reports.',
    gate_login: 'Log in',
    gate_register: 'Register',
  },
  ru: {
    login: 'Вход / Регистрация',
    cabinet: 'Личный кабинет',
    gate_title: 'Отчёты доступны после регистрации',
    gate_text: 'Войдите или создайте бесплатный аккаунт, чтобы получить доступ к отчётам фонда.',
    gate_login: 'Войти',
    gate_register: 'Регистрация',
  },
  uk: {
    login: 'Вхід / Реєстрація',
    cabinet: 'Особистий кабінет',
    gate_title: 'Звіти доступні після реєстрації',
    gate_text: 'Увійдіть або створіть безкоштовний акаунт, щоб отримати доступ до звітів фонду.',
    gate_login: 'Увійти',
    gate_register: 'Реєстрація',
  },
  de: {
    login: 'Anmelden / Registrieren',
    cabinet: 'Mein Konto',
    gate_title: 'Berichte sind nach der Registrierung verfügbar',
    gate_text: 'Melden Sie sich an oder erstellen Sie ein kostenloses Konto, um auf die Berichte des Fonds zuzugreifen.',
    gate_login: 'Anmelden',
    gate_register: 'Registrieren',
  },
  fr: {
    login: 'Connexion / Inscription',
    cabinet: 'Mon espace',
    gate_title: 'Les rapports sont accessibles après inscription',
    gate_text: 'Connectez-vous ou créez un compte gratuit pour accéder aux rapports de la fondation.',
    gate_login: 'Se connecter',
    gate_register: 'S’inscrire',
  },
  es: {
    login: 'Entrar / Registrarse',
    cabinet: 'Mi cuenta',
    gate_title: 'Los informes están disponibles tras registrarse',
    gate_text: 'Inicie sesión o cree una cuenta gratuita para acceder a los informes de la fundación.',
    gate_login: 'Entrar',
    gate_register: 'Registrarse',
  },
};

export const getAuthLabels = (language) => AUTH_LABELS[language] || AUTH_LABELS.en;
